// extracted by mini-css-extract-plugin
export default {"success":"ErrorPage_success__kKmwn","image":"ErrorPage_image__5FBkH","btn":"ErrorPage_btn__Bps+X","message":"ErrorPage_message__r4BuZ","link":"ErrorPage_link__HUqPb"};